import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedShippingAddress } from '../Actions/Checkout.action';
import { translate } from '../Services/translation';
import constants from '../constants';

const BusinessCustomerShippingAddress = () => {
    const dispatch = useDispatch();
    const { payload } = useSelector((state) => state.checkout);
    const { shippingAddresses = [], selectedShippingAddressId } = payload;

    const onShippingAddressChange = (addressId) => {
        dispatch(setSelectedShippingAddress(addressId));
    };

    const getCountry = (address) => {
        const country = constants.countries ? constants.countries.find((x) => x.value === address.country) : null;
        return country ? country.text : address.country;
    };

    const formattedAddress = (address) => {
        return [address.address, address.zipCode, address.city, getCountry(address)].filter((x) => !!x).join(', ');
    };

    if (!shippingAddresses || shippingAddresses.length === 0) {
        return null;
    }

    return (
        <Fragment>
            <label htmlFor="checkout.shippinginfo.address" className="form__label">
                {translate('checkout.shippinginfo.address')}
            </label>
            <select
                id="checkout.shippinginfo.address"
                className="form__input"
                value={selectedShippingAddressId}
                onChange={(event) => onShippingAddressChange(event.target.value)}
            >
                {shippingAddresses.map((address) => (
                    <option value={address.systemId} key={address.systemId}>
                        {formattedAddress(address)}
                    </option>
                ))}
            </select>
        </Fragment>
    );
};

export default BusinessCustomerShippingAddress;
